import { useState, useMemo, useEffect } from 'react';
import { fetchContentTypeOnly } from 'utils';
import { contentTypeIsHls, contentTypeIsMp4 } from 'services/video/utils';

/**
 * This hook is private to Video
 */
export const usePlayerContentType = (url?: string) => {
  const [contentType, setContentType] = useState(null as string | null);

  const urlHasMp4 = useMemo(
    () => (/\.mp4$/i).test(url || ''),
    [url],
  );

  const urlHasHls = useMemo(
    () => (/\.m3u8$/i).test(url || ''),
    [url],
  );

  useEffect(
    () => {
      if (!urlHasMp4 && !urlHasHls && url)
        fetchContentTypeOnly(url)
          .then(setContentType);
    },
    [url, urlHasMp4, urlHasHls],
  );

  return {
    isMp4: urlHasMp4 || contentTypeIsMp4(contentType || ''),
    isHLS: urlHasHls || contentTypeIsHls(contentType || ''),
    contentType,
    urlHasMp4,
    urlHasHls,
  };
};
